module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-226.09f6f60c.svg";